.section-component {
  margin: 0 0.5rem 0.6rem;
}
.section-component .section-title {
  margin: 0 0.6rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
}
.section-component .section-content {
  display: flex;
  height: 100%;
}
.section-component .section-content > * {
  padding: 0 0.3rem;
  box-sizing: border-box;
  flex: 0 0 100%;
}
.section-component.align-height .section-content {
  align-items: stretch;
}
.section-component.align-height .section-content .column-component .column-content {
  height: 100%;
}
.section-component.align-height .section-content .column-component .column-content .panel-component {
  height: 100%;
}
.section-component.align-height .section-content .column-component .column-content .panel-component.full-screen {
  height: calc(100% - 0.9rem + 19px);
}
.section-component.align-height .section-content .column-component .column-content .panel-component .component-renderer-component {
  height: 100%;
  overflow: auto;
}
.section-component.with-2-columns .section-content > *:first-child {
  flex-basis: 66.66666%;
  max-width: 66.66666%;
}
.section-component.with-2-columns .section-content > *:last-child {
  flex-basis: 33.3333%;
  max-width: 33.3333%;
}
.section-component.with-3-columns .section-content > * {
  flex-basis: 33.3333%;
  max-width: 33.3333%;
}
.section-component.with-4-columns .section-content > * {
  flex-basis: 25%;
  max-width: 25%;
}
.section-component.with-5-columns .section-content > * {
  flex-basis: 20%;
  max-width: 20%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */